export class PaymentInfoMapper {
  static toErrorPayment(data) {
    if (!data || !data.errors)
      return undefined;

    const errorsText = Object.values(data.errors).flat().join(', ')

    return {
        paymentAllowed: data?.paymentAllowed || false,
        errorCode: data?.errorCode || '',
        errorMessage: data?.errorMessage || '',
        paymentMessage: errorsText || '',
    }
  }

  static toInfoPayment(data) {
    const allowedPaymentProviders = (data?.allowedPaymentProviders || []).map(({provider}) => provider);
    const providerType = allowedPaymentProviders.includes(data.providerType)
        ? data.providerType
        : data.providerType?.length > 0 ? data.providerType : allowedPaymentProviders[0];

    const paymentAccountPubKey = providerType === data?.providerType
        ? data?.paymentAccountPubKey || ''
        : data?.allowedPaymentProviders?.find(({provider}) => provider === providerType)?.publicKey || ''

    return {
      allowedPaymentProviders: data?.allowedPaymentProviders || [],
      country: data?.country || '',
      description: data?.description || '',
      language: data?.language || '',
      commonCurrencyList: data?.commonCurrencyList || '',
      amount: data?.amount || 0,
      currency: data?.currency || '',
      defaultAmount: data?.amount || 0,
      defaultCurrency: data?.currency || '',
      isConvertAllowed: data?.isConvertAllowed || false,
      companyName: data?.merchantName || '',
      companyLogo: data?.merchantLogoBase64 || '',
      merchantPubKey: data?.merchantPubKey || '',
      returnUrlSuccess: data?.returnUrlSuccess || '',
      returnUrlCancel: data?.returnUrlCancel || '',
      disallowedCardBrands: data?.disallowedCardBrands || [],
      termsAndConditions: data?.termsAndConditionsHTML || '',
      companyStyle: data?.styles || undefined,
      paymentSchedule: data?.paymentSchedule,
      type: data?.type,
      lineItems: data?.lineItems || [],
      hotelDetails: data?.hotelDetails,
      showCountryDropdown: data?.showCountryDropdown,
      isPaymentByCardAllowed: data?.isPaymentByCardAllowed,
      isCardBrandBannerVisible: data?.isCardBrandBannerVisible || false,
      paymentAllowed: data?.paymentAllowed,
      paymentMessage: data?.paymentMessage,
      jsonStyle: data?.JsonStyle || '',
      showSaveCard: data?.showSaveCard || false,
      currencyDecimals: data?.currencyDecimals === undefined || data?.currencyDecimals === null ? 2 : data?.currencyDecimals,
      confirmation3dsLink: data?.confirmation3dsLink || '',
      metadata3ds: JSON.parse(data?.metadata3ds || `{}`),
      status: data?.status || '',
      paymentIntentAmount: data?.paymentIntentAmount || 0,
      paymentAccountPubKey,
      paymentProcessedDate: data?.paymentProcessedDate || '',
      paymentCardLast4: data?.paymentCardLast4 || '',
      clientSecret: data?.clientSecret || '',
      showPayNow: data?.showPayNow || false,
      providerType: providerType.toLowerCase(),
      transactionId: data?.transactionId || '',
      payerName: data?.payerName || '',
      payerEmail: data?.payerEmail || '',
      payerPhone: data?.payerPhone || '',
      payerAddress: data?.payerAddress || '',
      payerCity: data?.payerCity || '',
      payerPostCode: data?.payerPostCode || '',
    }
  }
}
